import React, { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

const BaseRoute = ({ children }: Props) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  if (isLoggedIn) {
    window.location.href = `/dashboard`;
  }

  return children ? <>{children}</> : null;
};

export default BaseRoute;
